// client/src/components/EditPOI_parts/EditPOI_ImageUpload.js
import React from 'react';

export default function EditPOIImageUpload({
  edit,
  imageFile,
  setImageFile,
  imageUploading,
  imageError,
  imageMsg,
  onUpload,
  onCancel,
}) {
  return (
    <div
      style={{
        background: '#232427',
        borderRadius: 12,
        padding: 24,
        marginTop: 10,
        marginBottom: 10,
        minWidth: 340,
        boxShadow: '0 2px 20px #000c',
        color: '#fff',
      }}
    >
      <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 14 }}>
        Upload Image (PNG, JPG, GIF, max 1MB)
      </div>
      <input
        type="file"
        accept="image/png,image/jpeg,image/jpg,image/gif,image/webp"
        onChange={e => setImageFile(e.target.files?.[0] || null)}
        disabled={imageUploading}
      />
      <div style={{ marginTop: 11, fontSize: 13 }}>
        {imageFile && (
          <span>
            Selected: {imageFile.name} ({Math.round(imageFile.size / 1024)} KB)
          </span>
        )}
      </div>
      {imageError && (
        <div style={{ color: '#f44c2b', marginTop: 7, fontSize: 13 }}>{imageError}</div>
      )}
      {imageMsg && (
        <div style={{ color: '#81ff9c', marginTop: 7, fontSize: 13 }}>{imageMsg}</div>
      )}
      <div style={{ marginTop: 15, display: 'flex', gap: 12 }}>
        <button
          onClick={() => {
            if (imageFile) onUpload(imageFile);
          }}
          disabled={!imageFile || imageUploading}
          style={{
            background: '#4cc153',
            color: '#fff',
            border: 'none',
            borderRadius: 7,
            padding: '7px 18px',
            fontWeight: 700,
            fontSize: 15,
            cursor: 'pointer',
          }}
        >
          Upload
        </button>
        <button
          onClick={onCancel}
          style={{
            background: '#333',
            color: '#fff',
            border: 'none',
            borderRadius: 7,
            padding: '7px 18px',
            fontWeight: 700,
            fontSize: 15,
            cursor: 'pointer',
          }}
        >
          Cancel
        </button>
      </div>
      {(imageFile || edit.imageUrl) && (
        <div style={{ marginTop: 10 }}>
          <img
            src={imageFile ? URL.createObjectURL(imageFile) : edit.imageUrl}
            alt="Preview"
            style={{ width: 120, maxHeight: 90, borderRadius: 4, border: '1px solid #888' }}
            onError={e => {
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>
      )}
    </div>
  );
}
